import { Dashboard } from './../../shared/interceptors/token.interceptors';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');

  constructor(private _http: HttpClient, private router: Router) {}

  /**
   * logOut
   * La función envía los headers que contienen el token del usuario a cerrar sesión
   */
  async logOut() {
    await this._http
      .post(environment.login_logout, {}, { headers: this.headers })
      .toPromise()
      .then((data) => {
        console.log(data);
        localStorage.clear();
        this.router.navigate(['']);
      })
      .catch((error) => {
        console.log(error);
        localStorage.clear();
        this.router.navigate(['']);
      });
  }
}
